import { BaseModel } from "../../../core/models";
import { GroupStatus, type GroupWithConnections } from "../../../../gql-generated/types";
import { DateConvert } from "../../../lenses/domain/services/DateConvert";

import { GroupsGridLensModel } from "./GroupsGridLensModel";

export class GroupsGridItemModel {
    readonly id: string | null = null;
    readonly name: string | null = null;
    readonly description: string | null = null;
    readonly lenses: readonly GroupsGridLensModel[] = [];
    readonly totalNumLenses: number = 0;
    readonly lastUpdated: Date | null = null;
    readonly readOnly: boolean | null = null;
    readonly isPinned: boolean | null = null;
    readonly isArchived: boolean | null = null;

    static createFromGroupWithConnections({ group, connections }: GroupWithConnections): GroupsGridItemModel {
        return BaseModel.createInstance(GroupsGridItemModel, {
            id: group?.id,
            name: group?.name,
            description: group?.description,
            totalNumLenses: group?.totalNumLenses ?? 0,
            lenses: connections
                ?.filter((lensItem) => !lensItem?.lens?.removed)
                .map((connection) => GroupsGridLensModel.createFromGroupLensConnection(connection!)),
            lastUpdated: DateConvert.toDate(group?.updatedAt),
            readOnly: group?.readOnly,
            isPinned: group?.isPinned,
            isArchived: group?.status === GroupStatus.Archived,
        });
    }
}
